import type { RespondentField } from '../../lib/multimodal-contract';

/** Use authored examples first, with recognizable defaults for constrained answers. */
export function answerPlaceholder(field: RespondentField | null | undefined): string {
  if (field?.placeholder?.trim()) return field.placeholder;
  if (field?.type === 'email' || field?.calendar?.input === 'email') return 'you@example.com';
  if (field?.type === 'short_text' && field.textFormat === 'url') return 'https://example.com';
  if (field?.type === 'number') {
    if (field.min !== undefined && field.max !== undefined) return `${field.min} to ${field.max}`;
    if (field.min !== undefined) return `${field.min} or more`;
    if (field.max !== undefined) return `${field.max} or less`;
    return 'e.g. 42';
  }
  return field?.type === 'phone' ? 'Phone number' : 'Your answer';
}
